// ==========================================
// COMMON UTILITIES (SHARED)
// ==========================================
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";

// ==========================================
// PROGRAM MANAGEMENT ACTION TYPES
// ==========================================
export const PROGRAMS_REQUEST = "PROGRAMS_REQUEST";
export const PROGRAMS_SUCCESS = "PROGRAMS_SUCCESS";
export const PROGRAMS_GET_SUCCESS = "PROGRAMS_GET_SUCCESS";
export const PROGRAMS_VALIDATION_ERROR = "PROGRAMS_VALIDATION_ERROR";
export const PROGRAMS_REDIRECT = "PROGRAMS_REDIRECT";
export const HIDE_PROGRAMS_FEILD_VALIDATION_ERROR =
  "HIDE_PROGRAMS_FEILD_VALIDATION_ERROR";
export const PROGRAMS_DROPDOWN_SUCCESS = "PROGRAMS_DROPDOWN_SUCCESS";

// ==========================================
// BRAND MANAGEMENT ACTION TYPES
// ==========================================
export const BRANDS_REQUEST = "BRANDS_REQUEST";
export const BRANDS_SUCCESS = "BRANDS_SUCCESS";
export const BRANDS_GET_SUCCESS = "BRANDS_GET_SUCCESS";
export const BRANDS_VALIDATION_ERROR = "BRANDS_VALIDATION_ERROR";
export const BRANDS_REDIRECT = "BRANDS_REDIRECT";
export const HIDE_BRANDS_FEILD_VALIDATION_ERROR =
  "HIDE_BRANDS_FEILD_VALIDATION_ERROR";
export const BRANDS_DROPDOWN_SUCCESS = "BRANDS_DROPDOWN_SUCCESS";

// ==========================================
// QUEUE MANAGEMENT ACTION TYPES
// ==========================================
export const QUEUES_REQUEST = "QUEUES_REQUEST";
export const QUEUES_SUCCESS = "QUEUES_SUCCESS";
export const QUEUES_GET_SUCCESS = "QUEUES_GET_SUCCESS";
export const QUEUES_VALIDATION_ERROR = "QUEUES_VALIDATION_ERROR";
export const QUEUES_REDIRECT = "QUEUES_REDIRECT";
export const HIDE_QUEUES_FIELD_VALIDATION_ERROR =
  "HIDE_QUEUES_FIELD_VALIDATION_ERROR";
export const QUEUES_DROPDOWN_SUCCESS = "QUEUES_DROPDOWN_SUCCESS";

// ==========================================
// DIRECTION MANAGEMENT ACTION TYPES
// ==========================================
export const DIRECTIONS_REQUEST = "DIRECTIONS_REQUEST";
export const DIRECTIONS_SUCCESS = "DIRECTIONS_SUCCESS";
export const DIRECTIONS_GET_SUCCESS = "DIRECTIONS_GET_SUCCESS";
export const DIRECTIONS_VALIDATION_ERROR = "DIRECTIONS_VALIDATION_ERROR";
export const DIRECTIONS_REDIRECT = "DIRECTIONS_REDIRECT";
export const HIDE_DIRECTIONS_FEILD_VALIDATION_ERROR =
  "HIDE_DIRECTIONS_FEILD_VALIDATION_ERROR";
export const DIRECTIONS_DROPDOWN_SUCCESS = "DIRECTIONS_DROPDOWN_SUCCESS";

// ==========================================
// LANGUAGE MANAGEMENT ACTION TYPES
// ==========================================
export const LANGUAGES_REQUEST = "LANGUAGES_REQUEST";
export const LANGUAGES_SUCCESS = "LANGUAGES_SUCCESS";
export const LANGUAGES_GET_SUCCESS = "LANGUAGES_GET_SUCCESS";
export const LANGUAGES_VALIDATION_ERROR = "LANGUAGES_VALIDATION_ERROR";
export const LANGUAGES_REDIRECT = "LANGUAGES_REDIRECT";
export const HIDE_LANGUAGES_FEILD_VALIDATION_ERROR =
  "HIDE_LANGUAGES_FEILD_VALIDATION_ERROR";
export const LANGUAGES_DROPDOWN_SUCCESS = "LANGUAGES_DROPDOWN_SUCCESS";

// ==========================================
// BUSINESS MANAGEMENT ACTION TYPES
// ==========================================
export const BUSINESSES_REQUEST = "BUSINESSES_REQUEST";
export const BUSINESSES_SUCCESS = "BUSINESSES_SUCCESS";
export const BUSINESSES_GET_SUCCESS = "BUSINESSES_GET_SUCCESS";
export const BUSINESSES_VALIDATION_ERROR = "BUSINESSES_VALIDATION_ERROR";
export const BUSINESSES_REDIRECT = "BUSINESSES_REDIRECT";
export const HIDE_BUSINESSES_FEILD_VALIDATION_ERROR =
  "HIDE_BUSINESSES_FEILD_VALIDATION_ERROR";
export const BUSINESSES_DROPDOWN_SUCCESS = "BUSINESSES_DROPDOWN_SUCCESS";

// ==========================================
// GEOGRAPHY MANAGEMENT ACTION TYPES
// ==========================================
export const GEOGRAPHIES_REQUEST = "GEOGRAPHIES_REQUEST";
export const GEOGRAPHIES_SUCCESS = "GEOGRAPHIES_SUCCESS";
export const GEOGRAPHIES_GET_SUCCESS = "GEOGRAPHIES_GET_SUCCESS";
export const GEOGRAPHIES_VALIDATION_ERROR = "GEOGRAPHIES_VALIDATION_ERROR";
export const GEOGRAPHIES_REDIRECT = "GEOGRAPHIES_REDIRECT";
export const HIDE_GEOGRAPHIES_FEILD_VALIDATION_ERROR =
  "HIDE_GEOGRAPHIES_FEILD_VALIDATION_ERROR";
export const GEOGRAPHIES_DROPDOWN_SUCCESS = "GEOGRAPHIES_DROPDOWN_SUCCESS";

// ==========================================
// SUPPRESS MANAGEMENT ACTION TYPES
// ==========================================
export const SUPPRESSES_REQUEST = "SUPPRESSES_REQUEST";
export const SUPPRESSES_SUCCESS = "SUPPRESSES_SUCCESS";
export const SUPPRESSES_GET_SUCCESS = "SUPPRESSES_GET_SUCCESS";
export const SUPPRESSES_VALIDATION_ERROR = "SUPPRESSES_VALIDATION_ERROR";
export const SUPPRESSES_REDIRECT = "SUPPRESSES_REDIRECT";
export const HIDE_SUPPRESSES_FEILD_VALIDATION_ERROR =
  "HIDE_SUPPRESSES_FEILD_VALIDATION_ERROR";
export const SUPPRESSES_DROPDOWN_SUCCESS = "SUPPRESSES_DROPDOWN_SUCCESS";

// Generic Configuration Action Types
export const CONFIGURATIONS_REQUEST = 'CONFIGURATIONS_REQUEST';
export const CONFIGURATIONS_SUCCESS = 'CONFIGURATIONS_SUCCESS';
export const CONFIGURATIONS_GET_SUCCESS = 'CONFIGURATIONS_GET_SUCCESS';
export const CONFIGURATIONS_DROPDOWN_SUCCESS = 'CONFIGURATIONS_DROPDOWN_SUCCESS';
export const CONFIGURATIONS_VALIDATION_ERROR = 'CONFIGURATIONS_VALIDATION_ERROR';
export const HIDE_CONFIGURATIONS_FEILD_VALIDATION_ERROR = 'HIDE_CONFIGURATIONS_FEILD_VALIDATION_ERROR';
export const CONFIGURATIONS_REDIRECT = 'CONFIGURATIONS_REDIRECT';